/**
 * Translation keys for the users list page
 */
export const TRANSLATION_KEYS = {
  FIELDS: {
    EMAIL: 'pages.users.fields.email',
    FIRST_NAME: 'pages.users.fields.firstName',
    LAST_NAME: 'pages.users.fields.lastName',
    ROLES: 'pages.users.fields.roles',
    CREATED_AT: 'pages.users.fields.createdAt',
  },
  SEARCH: {
    CLEAR_BUTTON: 'pages.users.search.clearButton',
    NO_RESULTS: 'pages.users.search.noResults',
  },
  TABLE: {
    ACTIONS: 'table.actions',
  },
  ROLES: {
    PREFIX: 'roles.',
  },
  DATA_GRID: {
    PAGINATION: {
      DISPLAY_ROWS: 'dataGrid.pagination.displayRows',
      ROWS_PER_PAGE: 'dataGrid.pagination.rowsPerPage',
      FIRST_PAGE: 'dataGrid.pagination.firstPage',
      LAST_PAGE: 'dataGrid.pagination.lastPage',
      NEXT_PAGE: 'dataGrid.pagination.nextPage',
      PREVIOUS_PAGE: 'dataGrid.pagination.previousPage',
    },
  },
} as const;
